'use strict';

let routes = function ($stateProvider, baseState) {

    $stateProvider

        .state('' + baseState + '', {
            abstract: true,
            url: "/good-enough-source-material-for-a-vat-declaration",
            views: {
                '': {
                    template: "<ui-view/>",
                },
                'sidebar@root': {
                    template: '<nav class="navbar-default navbar-static-side" role="navigation"><section-books-good-enough-source-material-for-a-vat-declaration-side-menu></section-books-good-enough-source-material-for-a-vat-declaration-side-menu></nav>'
                }
            },
            data: {
                workflowBaseState: baseState,
                showSideMenu: true
            }
        })

        .state('' + baseState + '.overview', {
            url: "/overview",
            template: require("./overview.html"),
            data: {pageTitle: 'Import'}
        })

        .state('' + baseState + '.ledgers-overview', {
            url: "/ledgers",
            template: require("../ledgers-overview.html"),
            data: {pageTitle: 'Import'}
        });

    let gaiSubsection = require('subsections/grant-and-import/grant-and-import.routing');
    gaiSubsection.routes($stateProvider, '' + baseState + '');

    $stateProvider

        .state('' + baseState + '.inspect', {
            abstract: true,
            url: "/organize",
            template: "<ui-view/>",
        })

        .state('' + baseState + '.inspect.overview', {
            url: "/overview",
            template: require("../inspect.overview.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.inspect.calendar', {
            abstract: true,
            url: "/calendar",
            template: require("../inspect.calendar.html"),
        })

        .state('' + baseState + '.inspect.calendar.overview', {
            url: "/overview",
            template: require("../inspect.calendar.overview.html"),
            data: {pageTitle: 'Inspect'}
        });

    let ilSubsection = require('subsections/inspect-ledger-contents/inspect-ledger-contents.routing');
    ilSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    let mmSubsection = require('subsections/money-movements/money-movements');
    mmSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    let beSubsection = require('subsections/business-events/business-events');
    beSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    let wSubsection = require('subsections/whereabouts/whereabouts');
    wSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

    let sdSubsection = require('subsections/supporting-documents/supporting-documents');
    sdSubsection.loadRoutesLazily($stateProvider, '' + baseState + '');

};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.**', {
        url: "/good-enough-source-material-for-a-vat-declaration",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/sections/6-books/good-enough-source-material-for-a-vat-declaration/routes.js